import useApi from "./request";

export interface NewsInfo {
    id: string;
    url: string;
    link: string;
    title: string;
    contentType: string;
    sourceId: string;
    sourceName: string;
    sourceLogo: string;
    publishDate: string;
    lookCount: number;
    score: number;
    status: number;
    topSort: null;
    importanceType: number;
    whetherImportance: number;
    language: string;
    createAt: string;
    goodCount: number;
    goodRate: null;
    badCount: number;
    badRate: null;
    content: string;
    clickStatus: null;
    collectStatus: null;
    lookStatus: null;
    del: number;
}

export async function getNewsInfoApi(newsId: string) {
    let { response, request } = useApi<{
        code: number;
        message: string;
        result: NewsInfo;
    }>(
        `/news/shareDetail/${newsId}`,
        {
            method: "get",
        }
    );
    await request();
    return response;
}